import { render, staticRenderFns } from "./PhotoCapture.vue?vue&type=template&id=575f2c77&scoped=true&"
import script from "./PhotoCapture.vue?vue&type=script&lang=js&"
export * from "./PhotoCapture.vue?vue&type=script&lang=js&"
import style0 from "./PhotoCapture.vue?vue&type=style&index=0&id=575f2c77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575f2c77",
  null
  
)

component.options.__file = "PhotoCapture.vue"
export default component.exports